import { render } from "./contact-details.vue?vue&type=template&id=183ae445"
import script from "./contact-details.vue?vue&type=script&lang=js"
export * from "./contact-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__